import { render, staticRenderFns } from "./IconWorkflow.vue?vue&type=template&id=2996529e&"
import script from "./IconWorkflow.vue?vue&type=script&lang=js&"
export * from "./IconWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports